import {
  PopupNotificationComponent,
  PopupNotificationData,
  Theme,
  PopupNotificationType,
} from 'studio-components';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PopupNotificationService {
  public openNotification(
    theme: Theme,
    type: PopupNotificationType,
    title: string,
    description: string,
    duration?: number,
  ) {
    this.snackBar.openFromComponent(PopupNotificationComponent, {
      data: {
        theme,
        type,
        title,
        description,
      } as PopupNotificationData,
      panelClass: 'studio-popup-notification',
      duration,
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }

  public closeNotification() {
    this.snackBar.dismiss();
  }

  constructor(public snackBar: MatSnackBar) {}
}
